import * as React from 'react';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import { Input } from 'components/spaceKit';
import { useCallback } from 'react';

type InputTypes = 'text' | 'number' | 'textArea' | 'password' | 'time';
type ActionInputProps = {
    value: string | null;
    option: any;
    hasError?: boolean;
    active?: boolean;
    disabled?: boolean;
    placeholder?: string;
    className?: any;
    focusOnRender?: boolean;
    type?: InputTypes;
    min?: number;
    max?: number;
};

const focus = node => node?.select();

function ActionInput({
    value,
    option,
    focusOnRender,
    hasError,
    active,
    disabled,
    placeholder,
    className,
    type,
    min,
    max,
}: ActionInputProps) {
    const handleChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            if (type === 'number') {
                // limit the input to the max if max is set
                const eventValue = parseInt(event.target.value, 10);
                const maxedValue = !!max ? Math.min(eventValue, max) : eventValue;
                runInAction(() => (option[value] = `${maxedValue}`));
            } else {
                runInAction(() => (option[value] = event.target.value));
            }
        },
        [max, option, type, value]
    );
    return (
        <Input
            ref={focusOnRender ? focus : undefined}
            type={type}
            className={className}
            value={option[value]}
            disabled={disabled}
            hasError={hasError}
            active={active}
            placeholder={placeholder}
            min={min}
            max={max}
            onChange={handleChange}
        />
    );
}

ActionInput.displayName = 'ActionInput';
export default observer(ActionInput);
